import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

const dailyReportAdaptor = createEntityAdapter({
    selectId: (entity) => entity.id,
})
const initialDailyReport = dailyReportAdaptor.getInitialState()

export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getDailyReportDate: builder.query({
            query: ({ countPage, geoId }) => `/b2g/eco-admin/segregation?page=${countPage}&limit=12&geo_id=${geoId}`,
            transformResponse: responseData => {
                const { total_pages, data } = responseData?.data
                return { total_pages, entities: data };
            },

            providesTags: (result, error, arg) => {
                if (error) {
                    return []
                }
                if (result?.entities) {
                    return [
                        { type: 'DailyReportDate', id: 'List' },
                        ...result.entities.map((iec) => ({ type: 'DailyReportDate', id: iec.id })),
                    ];
                }
            }
        }),
        getGeofance: builder.query({
            query: () => `/b2g/eco-admin/address/community/ward/geo-fance`,
            transformResponse: responseData => {
                return responseData?.data;
            },
        }),
        getWard: builder.query({
            query: () => `/b2g/eco-admin/address/community/ward?is_survey=1`,
            transformResponse: responseData => {
                return responseData?.data;
            },
        }),
        getDailyReport: builder.query({
            query: ({ page, searchDailyReport, date }) => {

                let queryString = `b2g/eco-admin/segregation/${date}?page_number=${page}`;

                if (!searchDailyReport.start_date && !searchDailyReport.end_date && !searchDailyReport.prp_name && !searchDailyReport.is_segregate && !searchDailyReport.is_collected && !searchDailyReport.geo_id && !searchDailyReport.ward_id && !searchDailyReport.image) {
                    // No query parameters added since all are empty
                }
                else {
                    // Add start_date, end_date, prp_name, is_segregate, and is_collected if they are provided
                    if (searchDailyReport.start_date) {
                        queryString += `&start_date=${searchDailyReport.start_date}`;
                    }

                    if (searchDailyReport.end_date) {
                        queryString += `&end_date=${searchDailyReport.end_date}`;
                    }

                    if (searchDailyReport.prp_name) {
                        queryString += `&prp_name=${searchDailyReport.prp_name}`;
                    }

                    if (searchDailyReport.is_segregate !== undefined) {
                        queryString += `&is_segregate=${searchDailyReport.is_segregate}`;
                    }

                    if (searchDailyReport.is_collected !== undefined) {
                        queryString += `&is_collected=${searchDailyReport.is_collected}`;
                    }
                    if (searchDailyReport.geo_id !== undefined) {
                        queryString += `&geo_id=${searchDailyReport.geo_id}`;
                    }
                    if (searchDailyReport.ward_id !== undefined) {
                        queryString += `&ward_id=${searchDailyReport.ward_id}`;
                    }
                    if (searchDailyReport.image !== undefined) {
                        queryString += `&image=${searchDailyReport.image}`;
                    }
                }
                return queryString;
            },
            transformResponse: responseData => {
                const { total, totalPage, data } = responseData?.data
                return { total, totalPage, entities: data };
            },

            providesTags: (result, error, arg) => {
                if (error) {
                    return []
                }
                if (result?.entities) {
                    return [
                        { type: 'DailyReport', id: 'List' },
                        ...result.entities.map((iec) => ({ type: 'DailyReport', id: iec.id })),
                    ];
                }
            }
        }),


    })
})

export const {
    useGetDailyReportQuery,
    useGetGeofanceQuery,
    useGetWardQuery,
    useGetDailyReportDateQuery
} = extendedApiSlice

// 1998